import React from "react";

const Minus = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill" d="M2 16h32v4H2z" fill={fill}/>
    </svg>
);

export default Minus;


